export default {
  namespaced: true,

  state: {
    selectedOrganization: null,
    userManagedOrganizations: [],
  },

  mutations: {
    MUTATE_SELECTED_ORGANIZATION(state, organization) {
      state.selectedOrganization = organization;
    },
    MUTATE_USER_MANAGED_ORGANIZATIONS(state, organizations) {
      state.userManagedOrganizations = Array.isArray(organizations) ? organizations : [];
    },
  },

  actions: {
    SET_SELECTED_ORGANIZATION({ commit }, organization) {
      commit('MUTATE_SELECTED_ORGANIZATION', organization);
    },
    SET_USER_MANAGED_ORGANIZATIONS({ commit }, organizations) {
      commit('MUTATE_USER_MANAGED_ORGANIZATIONS', organizations);
    },
  },

  getters: {
    GET_SELECTED_ORGANIZATION: (state) => state.selectedOrganization,
    GET_USER_MANAGED_ORGANIZATIONS: (state) => state.userManagedOrganizations,
    GET_USER_MANAGED_ORGANIZATION_IDS: (state) => state.userManagedOrganizations
      .map((org) => org?.id ?? org?.orgId)
      .filter(Boolean)
      .map((id) => String(id)),
  },
};
